module.exports = __webpack_public_path__ + "static/media/pic19.1bad8242.jpg";